import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import DonutChart from './DonutChart'
import { getEmotionDistribution } from '../../../server/server'
import { emotions_heads, emotions_list } from '../constants/Constants'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'
import '../../../styles/early/earlyMotion.css'

function DashboardAnalytics() {
    let history = useHistory()
    const [stats, setStats] = useState({})
    const [percentage, setPercentage] = useState(0)
    const [loading, setLoading] = useState(true)
    const { t } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.EARLY_DASHBOARD_ANALYTICS_VIEWED, {
        active: !loading,
        content: 'Class analytics',
    })

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const resp = await getEmotionDistribution()
        if (resp.status == 200) {
            const data = resp.data
            setPercentage(data.percentage)
            setStats(data.stats)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    return (
        <div className="flex flex-col p-9 rounded-2xl bg-white h-full">
            <p className="text-[24px] leading-[31px] font-bold text-[#5E639B]">{t('analytics')}</p>
            <p className="text-[14px] leading-[17px] font-medium text-[#413F5E] mt-2.5">{t('Stay up to date with student support')}</p>
            <div className="mt-5 p-1 flex items-center gap-4 border border-dashed border-[#5E639B] rounded-full w-full overflow-hidden">
                <DonutChart loading={loading} percentage={percentage} />
                <span className="text-[#413F5E] text-sm leading-[17px] font-medium flex-1">{t('% of students using Upstrive (per week, any function)')}</span>
            </div>
            <p className="mt-5 text-[#413F5E] text-lg leading-[26px] font-bold flex-1">{t('Emotions distribution')}</p>
            <div className="mt-5 em-stagger em-stagger-row">
                {emotions_list.map((item, index) => (
                    <div key={index} className="flex items-center gap-4 mb-2">
                        {emotions_heads[item]}
                        <div>
                            <span className="text-[#413F5E] text-lg leading-[23px] capitalize font-medium">
                                {t(item)} {stats[item] ?? 0}%
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            <Link to="/analytics/data?type=data&content=how-do-you-feel&primary=true">
                <div className="mt-4 flex items-center justify-center bg-[#5E639B] rounded-full h-[50px] w-full em-tap">
                    <span className="text-white text-lg leading-[23px] font-semibold">{t('Open analytics')}</span>
                </div>
            </Link>
        </div>
    )
}

export default DashboardAnalytics
